// @flow
import * as React from 'react';
import styled from 'styled-components';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { displayPercent } from 'common/components/Number';
import { openSnackbar } from 'common/modules/ui/actions/uiActions';
import SalesPromotion from 'common/modules/sales/domain/SalesPromotion';
import Banner from './components/Banner';
import SalesPromotionDialog from './components/SalesPromotionDialog';
import { fetchPromotions, acceptPromotion, declinePromotion } from './actions/promotionActions';
import { getProposedPromotions } from './selectors/promotionSelectors';

const BannersWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

type Props = {
  actions: {
    fetchPromotions: () => any;
    acceptPromotion: (promotion: SalesPromotion) => any;
    declinePromotion: (promotion: SalesPromotion) => any;
    openSnackbar: (kind: string, message: string) => any;
  };
  promotions: SalesPromotion[];
  t: (string, ?Object) => any;
};

type State = {
  salesPromotion: ?SalesPromotion;
  viewAllPromotions: boolean;
};

export class SalesPromotionBanners extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      salesPromotion: undefined,
      viewAllPromotions: false,
    };

    (this: any).onAcceptPromotion = this.onAcceptPromotion.bind(this);
    (this: any).onDeclinePromotion = this.onDeclinePromotion.bind(this);
  }

  componentWillMount() {
    this.props.actions.fetchPromotions();
  }

  componentWillReceiveProps(nextProps: Props) {
    if (nextProps.promotions.length <= 1) {
      this.setState({ viewAllPromotions: false });
    }
  }

  onViewPromotion = (promotion: SalesPromotion) => {
    this.setState({ salesPromotion: promotion });
  }

  onCloseDialog = () => {
    this.setState({ salesPromotion: undefined });
  }

  onViewAllPromotions = () => {
    this.setState({ viewAllPromotions: true });
  }

  onViewAllPromotionsClose = () => {
    this.setState({ viewAllPromotions: false });
  }

  async onAcceptPromotion() {
    if (this.state.salesPromotion) {
      try {
        await this.props.actions.acceptPromotion(this.state.salesPromotion);
        this.onCloseDialog();
        this.props.actions.openSnackbar('message', this.props.t('promotionHasBeenAccepted'));
      } catch (error) {
        this.props.actions.openSnackbar('error', this.props.t('errorAcceptingPromotion'));
      }
    }
  }

  async onDeclinePromotion() {
    if (this.state.salesPromotion) {
      try {
        await this.props.actions.declinePromotion(this.state.salesPromotion);
        this.onCloseDialog();
        this.props.actions.openSnackbar('message', this.props.t('promotionHasBeenDeclined'));
      } catch (error) {
        this.props.actions.openSnackbar('error', this.props.t('errorDecliningPromotion'));
      }
    }
  }

  renderPromotionBanners = () => {
    const { t } = this.props;

    if (this.state.viewAllPromotions) {
      return this.props.promotions.map((promotion, index) => {
        const isFirst = index === 0;

        return (
          this.renderPromotionBanner(promotion, isFirst)
        );
      });
    }

    return (
      <Banner
        title={t('hasNewPromotions', { count: this.props.promotions.length })}
        actionIcon="keyboard_arrow_down"
        onAction={this.onViewAllPromotions}
        bannerType={t('promotion')}
      />
    );
  }

  renderPromotionBanner = (promotion: SalesPromotion, withActionArrow?: boolean) => {
    const title = `${promotion.getTitle()} ${displayPercent(promotion.getDiscount())} ${this.props.t('discounted')}`;

    return (
      <Banner
        key={promotion.getReference()}
        title={title}
        actionIcon={withActionArrow ? 'keyboard_arrow_up' : ''}
        bannerType={this.props.t('promotion')}
        onAction={withActionArrow ? this.onViewAllPromotionsClose : undefined}
        onView={() => this.onViewPromotion(promotion)}
      />
    );
  }

  render() {
    const { promotions } = this.props;
    if (promotions.length === 0) {
      return null;
    }

    const hasMultiplePromotions = promotions.length > 1;
    const topPromotion = promotions[0];

    return (
      <BannersWrapper>
        {hasMultiplePromotions && this.renderPromotionBanners()}
        {!hasMultiplePromotions && topPromotion && this.renderPromotionBanner(topPromotion)}
        <SalesPromotionDialog
          promotion={this.state.salesPromotion}
          onClose={this.onCloseDialog}
          onAccept={this.onAcceptPromotion}
          onDecline={this.onDeclinePromotion}
        />
      </BannersWrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    promotions: getProposedPromotions(state),
  };
}

function mapDispatchToProps(dispatch: *) {
  return {
    actions: bindActionCreators({ fetchPromotions, acceptPromotion, declinePromotion, openSnackbar }, dispatch),
  };
}

export default translate('promotions')(connect(mapStateToProps, mapDispatchToProps)(SalesPromotionBanners));



// WEBPACK FOOTER //
// ./src/advertisers/modules/promotions/SalesPromotionBanners.js